import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, X } from "lucide-react";
import { api, formatNum } from "@/lib/api";

const FIELD = { tutar: "Tutar", iban: "IBAN", aciklama: "Açıklama" };
const fmt = (f, v) => (f === "tutar" ? formatNum(v) : v || "—");

const Section = ({ title, tone, children, count, testid }) => (
  <div className={`border rounded-lg ${tone}`} data-testid={testid}>
    <div className="px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider">{title} ({count})</div>
    {count > 0 && <div className="bg-white rounded-b-lg divide-y divide-slate-100">{children}</div>}
  </div>
);

export const BankCompareModal = ({ hist, onClose }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/payroll/bank-history/${hist.id}/compare`).then((r) => setD(r.data))
      .catch((e) => { toast.error(e?.response?.data?.detail || "Karşılaştırılamadı"); onClose(); });
  }, [hist.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const when = (h) => `${new Date(h.created_at).toLocaleString("tr-TR")} · ${h.created_by_name} · ${h.count} ödeme · ${formatNum(h.total)} ₺`;
  const same = d && !d.added.length && !d.removed.length && !d.changed.length;

  return (
    <div className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center p-4" data-testid="bank-compare-modal">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[85vh] flex flex-col">
        <div className="p-3 border-b flex items-center justify-between">
          <div className="text-sm font-bold text-slate-900">Talimat Karşılaştırma · {hist.filename}</div>
          <button onClick={onClose} data-testid="bank-compare-close" className="w-7 h-7 rounded-lg hover:bg-slate-100 grid place-items-center"><X size={14} /></button>
        </div>
        {!d ? <div className="p-8 text-center text-slate-400"><Loader2 size={16} className="inline animate-spin" /></div> : (
          <div className="p-3 space-y-3 overflow-y-auto text-xs">
            <div className="grid md:grid-cols-2 gap-2">
              <div className="bg-slate-50 border rounded p-2"><div className="font-bold text-slate-500 text-[10px] uppercase">Önceki</div>{when(d.previous)}</div>
              <div className="bg-sky-50 border border-sky-200 rounded p-2"><div className="font-bold text-sky-700 text-[10px] uppercase">Bu dosya</div>{when(d.current)}</div>
            </div>
            <div className="font-semibold" data-testid="bank-compare-total-diff">
              Toplam fark: <span className={d.current.total - d.previous.total >= 0 ? "text-emerald-700" : "text-rose-700"}>{formatNum(d.current.total - d.previous.total)} ₺</span>
            </div>
            {same && <div className="p-3 text-center bg-emerald-50 border border-emerald-200 rounded text-emerald-800" data-testid="bank-compare-same">İki dosya aynı · değişiklik yok</div>}
            <Section title="Eklenen" tone="border-emerald-200 bg-emerald-50 text-emerald-800" count={d.added.length} testid="bank-compare-added">
              {d.added.map((r) => <div key={r.personnel_id} className="px-3 py-1.5 flex justify-between"><span>{r.ad_soyad}</span><span className="font-mono-tab">{formatNum(r.tutar)}</span></div>)}
            </Section>
            <Section title="Çıkarılan" tone="border-rose-200 bg-rose-50 text-rose-800" count={d.removed.length} testid="bank-compare-removed">
              {d.removed.map((r) => <div key={r.personnel_id} className="px-3 py-1.5 flex justify-between"><span>{r.ad_soyad}</span><span className="font-mono-tab">{formatNum(r.tutar)}</span></div>)}
            </Section>
            <Section title="Değişen" tone="border-amber-200 bg-amber-50 text-amber-800" count={d.changed.length} testid="bank-compare-changed">
              {d.changed.map((c) => (
                <div key={c.personnel_id} className="px-3 py-1.5">
                  <div className="font-semibold text-slate-900">{c.ad_soyad}</div>
                  {Object.entries(c.diffs).map(([f, v]) => (
                    <div key={f} className="text-slate-600">{FIELD[f]}: <span className="line-through text-rose-600">{fmt(f, v.old)}</span> → <span className="text-emerald-700 font-semibold">{fmt(f, v.new)}</span></div>
                  ))}
                </div>
              ))}
            </Section>
          </div>
        )}
      </div>
    </div>
  );
};
